import {
	defaultNotificationStyleProps,
	NotificationStyleProps,
} from "@AppBuilderLib/features/notifications/config/notificationcontext";
import {useNotificationStore} from "@AppBuilderLib/features/notifications/model/useNotificationStore";
import {useSessionErrorNotifications} from "@AppBuilderLib/features/notifications/model/useSessionErrorNotifications";
import {MantineThemeComponent, useProps} from "@mantine/core";
import React, {useEffect} from "react";

interface Props {
	children?: React.ReactNode;
}

type NotificationWrapperThemePropsType = Partial<NotificationStyleProps>;

export function NotificationWrapperThemeProps(
	props: NotificationWrapperThemePropsType,
): MantineThemeComponent {
	return {
		defaultProps: props,
	};
}

/**
 * Initializes notification store with theme-based style props.
 * @param props
 * @returns
 */
export default function NotificationWrapper(
	props: Props & Partial<NotificationStyleProps>,
) {
	const {children = <></>, ...rest} = props;
	const _props = useProps(
		"NotificationWrapper",
		defaultNotificationStyleProps,
		rest,
	);
	const setStyleProps = useNotificationStore((state) => state.setStyleProps);

	// Initialize store with style props from theme
	useEffect(() => {
		setStyleProps(_props);
	}, [
		_props.errorColor,
		_props.successColor,
		_props.warningColor,
		_props.infoColor,
		_props.autoClose,
		setStyleProps,
	]);

	useSessionErrorNotifications();

	return <>{children}</>;
}
